module.exports = __webpack_public_path__ + "img/c05_unitcaravan_Normal_ua.2f4f87a8.webp";